import { render, staticRenderFns } from "./ModalDeleteTemplate.vue?vue&type=template&id=39191d12&"
import script from "./ModalDeleteTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports